import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import xmlChannelStatus from './modules/xmlChannelStatus';
import nav from './modules/nav';
import schedules from './modules/schedules';
import requestStatus from './modules/requestStatus';
import prices from './modules/prices';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    app,
    xmlChannelStatus,
    nav,
    schedules,
    requestStatus,
    prices,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js